<form [formGroup]="form" (ngSubmit)="submit()">
    <!-- 3,6,8,18 -->
    <!-- 15%,30%,45% 100% -->
     @let details = service.profile();
    <div class="custom-field max" [class.has-error]="!!form.get('name')!.errors">
        <label>First Name</label>
        <input matInput [placeholder]="details?.gender?.toLowerCase() == 'female' ? 'Jane' : 'John'" type="text" formControlName="name">
        <ng-container *ngTemplateOutlet="errorRender; context: { $implicit: 'name', label: 'First Name' }"></ng-container>

    </div>

    <div class="custom-field max" [class.has-error]="!!form.get('surname')!.errors">
        <label>Last Name</label>
        <input matInput placeholder="Borg" type="text" formControlName="surname" >
        <ng-container *ngTemplateOutlet="errorRender; context: { $implicit: 'surname', label: 'Last Name' }"></ng-container>

    </div>

    <div class="custom-field max" [class.disabled]="details?.email" [class.has-error]="!!form.get('email')!.errors">
        <label>Email Address</label>
        <input matInput placeholder="email@gmail.com" type="text" formControlName="email">
        <ng-container *ngTemplateOutlet="errorRender; context: { $implicit: 'email', label: 'Email' }"></ng-container>
    </div>

    <div class="custom-field {{size.width() >= 760 ? 'large' : 'max'}}" [class.disabled]="details?.phone" [class.has-error]="!!form.get('phone')!.errors">
        <label>Mobile Number</label>
        <div class="phone f-cross-center cgap-8">
            @defer{
              <lib-country-list #countryCodeInput [preferredCountryCodes]="['mt']" [selectedCountryCode]="'mt'" [countryListConfig]="{ hideCode: true }" [selectedCountryConfig]="{ hideCode: true, hideName: true }" (onCountryChange)="form.get('country_code')!.setValue($event.dialling_code||'+356')"></lib-country-list>
            }
            <input matInput type="tel" formControlName="phone" placeholder="99000000">
        </div>
        <ng-container *ngTemplateOutlet="errorRender; context: { $implicit: 'phone', label: 'Phone' }"></ng-container>
    </div>
    
    <div class="custom-field large" [class.has-error]="!!form.get('gender')!.errors">
        <label>Gender</label>
        <mat-select name="gender" formControlName="gender">
            <mat-option value="Male" class="package-option">Male</mat-option>
            <mat-option value="Female" class="package-option">Female</mat-option>
            <mat-option value="Unspecified" class="package-option">Unspecified</mat-option>
        </mat-select>
        <ng-container *ngTemplateOutlet="errorRender; context: { $implicit: 'gender', label: 'Gender' }"></ng-container>
    </div>

    <div class="custom-field large" [class.disabled]="details?.birthday" [class.has-error]="!!dob.errors">
        <label>Birthday</label>
        <div class="overlay" (click)="dobPicker.open()" (focus)="dobPicker.open()" tabIndex="0">
        </div>
        <mat-icon color="primary">event</mat-icon>
        <input class="cosmetic" matInput [matDatepicker]="dobPicker" placeholder="Date of Birth" [formControl]="dob" [min]="minDob" [max]="maxDob" tabIndex="-1">
        <mat-datepicker class="cosmetic" #dobPicker startView="multi-year" [startAt]="maxDob"></mat-datepicker>
        <ng-container *ngTemplateOutlet="errorRender; context: { $implicit: 'dob', label: 'Date of Birth' }"></ng-container>
    </div>
    <div class="custom-field {{size.width() >= 760 ? 'large' : 'max'}} disabled as-country" [class.has-error]="!!form.get('country')!.errors">
        <label>Country</label>
        <div class="phone">
          @defer{
            <lib-country-list #countryInput class="w-full" [countryListConfig]="{ hideCode: true, hideDialCode: true }" [selectedCountryConfig]="{ hideCode: true, hideDialCode: true }" (onCountryChange)="form.get('country')!.setValue($event.name||'Malta')"></lib-country-list>
          } @placeholder {
            <input matInput placeholder="Malta" type="text" formControlName="country" >
          }
        </div>
        <ng-container *ngTemplateOutlet="errorRender; context: { $implicit: 'country', label: 'Country' }"></ng-container>
    </div>
    <div class="custom-button f-col f-cross-center">
        <button mat-flat-button paint="plan-bg" type="submit" class="package-button" [disabled]="!form.dirty || this.service.loading()">
            Save Changes
        </button>
    </div>
</form>


<ng-template #errorRender let-field let-label="label">
    @if(form.get(field)?.touched && form.get(field)?.errors; as error){
      <mat-error>
        @if(error.required){
          {{label}} is required
        } @else if(error.email){
          {{label}} is not valid
        } @else if(error.bad){
          Please enter a different {{label}}
        } @else if(error.matDatepickerMax){
          You must be at least 16 years old to register
        } @else if(error.matDatepickerMin){
          You can't possibly be this old... right?
        } @else if(error.age){
          You must be at least 16 years old
        } @else {
          {{label}} is invalid
        }
      </mat-error>
    } @else {
      <mat-hint>&nbsp;</mat-hint>
    }
  </ng-template>